<template>
  <div class="container">
    <div class="f f-v f-as">
      <div class="about-me-section">
        <div
          v-for="(entriesByCategory, idx) in entriesByCategories(['bio']).value"
          :key="`bio-section-${idx}`"
          class="card surface m-bx2"
        >
          <div v-emoji="entriesByCategory.category.text" class="t-lg bold" />
          <div v-if="entriesByCategory.entries.every(entry => !entry.text)" class="t-lg gray italic m-tx2">
            No responses
          </div>
          <div
            v-for="(entry, entryIdx) in entriesByCategory.entries"
            :key="`bio-entry-${entryIdx}`"
            class="m-tx2"
          >
            <div v-if="entry.text" v-emoji="entry.text" class="t-lg" />
          </div>
        </div>
      </div>
      <div class="about-me-section p-bx3 m-bx3 w-100p">
        <div class="masonry-grid">
          <div
            v-for="(entriesByCategory, idx) in masonryCategories"
            :key="`masonry-category-${idx}`"
            class="masonry-item"
          >
            <div class="card surface">
              <div v-emoji="entriesByCategory.category.text" class="t-lg bold" />
              <div v-if="entriesByCategory.entries.every(entry => !entry.text)" class="t-lg gray italic m-tx2">
                No responses
              </div>
              <div v-else>
                <div
                  v-for="(entry, entryIdx) in entriesByCategory.entries"
                  :key="`entry-${entryIdx}`"
                >
                  <div v-if="entry.text" class="f-v m-tx2">
                    <div class="t-lg gray">{{ entry.field.text }}</div>
                    <div v-emoji="entry.text" class="t-lg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const { getters } = useStore();

const profileEntries = computed(() => getters['userProfileFields/profileEntries']);

const entriesByCategories = (categoryNames) => computed(() => profileEntries.value?.filter(entry => entry.category && categoryNames.includes(entry.category.machine_name)) || []);

const favoriteCategories = ['personal_history', 'activity', 'food', 'arts_and_entertainment'];
const coreCategories = ['experience', 'growth'];
const allMasonryCategoryNames = [...coreCategories, ...favoriteCategories];

const masonryCategories = computed(() => (
  profileEntries.value?.filter(entry => entry.category && allMasonryCategoryNames.includes(entry.category.machine_name)) || []
));
</script>

<style scoped lang="scss">
@import '../../styles/donut';

  .about-me-section {
    width: 100%;

    .divider {
      border-bottom: 2px solid $border;
    }
  }
</style>
